import React from 'react';
import CtaBox from 'components/cta-box/cta-box';
import CtaBoxTitle from 'components/cta-box/cta-box-title';
import CtaBoxMedia from 'components/cta-box/cta-box-media';
import Header3 from 'components/typography/header-3';
import P3 from 'components/typography/p-3';

// import Image from 'next/image';

const CARDS_TITLE_TEXT_GAP_COMPENSATION = 16;
const CARD_IMAGE_HEIGHT = 205;

export type CardContentPropsType = {
    imageUrl?: string;
    title?: string;
    text?: string;
    url?: string;
    headerTag?: 'h2' | 'h3' | 'h4';
};

const CardContent: React.FC<CardContentPropsType> = ({ imageUrl, title, text, url, headerTag }) => {
    const content = (
        <CtaBox full={true}>
            {title ? (
                <CtaBoxTitle>
                    <span className="card__title">
                        <Header3 color="var(--color-primary-01)" tag={headerTag}>
                            {url ? <a href={url}>{title}</a> : title}
                        </Header3>
                    </span>
                </CtaBoxTitle>
            ) : (
                ''
            )}

            {text ? (
                <CtaBoxTitle marginTop={CARDS_TITLE_TEXT_GAP_COMPENSATION}>
                    <span className="card__text">
                        <P3 color="var(--color-primary-01)">{text}</P3>
                    </span>
                </CtaBoxTitle>
            ) : (
                ''
            )}

            {imageUrl ? (
                <CtaBoxMedia marginTop={34}>
                    <div className="card__media">
                        {/* <Image */}
                        <img
                            className="cta-box__media-img"
                            src={imageUrl}
                            // width={280}
                            width="100%"
                            height={CARD_IMAGE_HEIGHT}
                            alt=""
                            // layout="responsive"
                            // objectFit="contain"
                            // objectPosition="center bottom"
                        />
                    </div>
                </CtaBoxMedia>
            ) : (
                <div style={{ height: CARD_IMAGE_HEIGHT }} />
            )}
        </CtaBox>
    );

    return content;
};

export default CardContent;
